<div class="card">
    <div class="card-header">
        Masters
    </div>
    <div class="card">
        <div class="card-body">
            <div class="row m-1">
                <div class="col-md-9 px-1">
                    <label class="Label">Enter {{Detail.SelectType}}</label>
                    <input name="master" type="text" class="form-control" [(ngModel)]="Detail.Name" />
                </div>
            </div>
            <div class="row m-1">
                <div class="col-md-3 px-1">
                    <!-- <label class="Label" style="margin-left: 3%;">
                        Active
                        <input type="checkbox" name="checkvalue" (change)="onCheckboxChange($event)"
                            [(ngModel)]="Detail.Active" ngbCheckbox />
                    </label> -->
                    <div class="form-check">
                        <label class="form-check-label" for="checkvalue">
                            Active 
                        </label>
                        <input mdbCheckbox class="form-check-input" (change)="onCheckboxChange($event)"
                            [(ngModel)]="Detail.Active" type="checkbox" value="" id="checkvalue" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-auto">
                        <button class="btn btn-sm btn-primary" name="btn3" (click)="cancel()"><i class="bi bi-x-lg"></i>
                            Close </button>
                    </div>
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="btn3" (click)="save()"><i class="bi bi-save"> </i>
                    Save </button>
            </div>
        </div>
    </div>
</div>